import { TableColumnItem, TableColumnTypeEnum } from '@ui-lib/components';

export const SCANNER_TABLE_COLUMNS: TableColumnItem[] = [
  {
    propName: 'createdDate',
    captionTranslateKey: 'monitoring.scanner.table.created-date',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'facility',
    captionTranslateKey: 'monitoring.scanner.table.facility',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'containersCount',
    captionTranslateKey: 'monitoring.scanner.table.container',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'scanResultsCount',
    captionTranslateKey: 'monitoring.scanner.table.founded',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'createdByUser',
    captionTranslateKey: 'monitoring.scanner.table.created-by',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'status',
    captionTranslateKey: 'monitoring.scanner.table.status',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'actions',
    type: TableColumnTypeEnum.Actions,
  },
];

export const SCANNER_RESULTS_TABLE_COLUMNS: TableColumnItem[] = [
  {
    propName: 'containerName',
    captionTranslateKey: 'monitoring.scanner.details.container',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'ipAddress',
    captionTranslateKey: 'monitoring.scanner.details.table.ip',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'model',
    captionTranslateKey: 'monitoring.scanner.details.table.device',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'macAddress',
    captionTranslateKey: 'monitoring.scanner.details.table.mac',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'result',
    captionTranslateKey: 'monitoring.scanner.details.table.current-status',
    type: TableColumnTypeEnum.Text,
  },
  {
    propName: 'detectedAtUtc',
    captionTranslateKey: 'monitoring.scanner.details.table.detected-at',
    type: TableColumnTypeEnum.Text,
  },
];
